import React from "react";
import {Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar";
import Home from "./routes/Home";
import About from "./routes/About";
import Services from "./routes/Services";
import Contact from "./routes/Contact";
import Gallery from "./components/Gallery";
import Destination from "./components/Destination";
import PackagesPage from "./components/Packages";
import "./style.css"


function App() {
  return (
    <div className="App">
    
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/destination" element={<Destination/>} />
        <Route path="/packages" element={<PackagesPage/>} />
      </Routes>

    </div>
  );
}

export default App;
